export const title = 'Vendas';
import CampaignAttributionDateNote from '../../shared/partials/campaign-attribution-date-note.pt.mdx';

Quantidade de vendas atribuídas a campanhas.

<CampaignAttributionDateNote />
